export default __webpack_public_path__ + "static/media/SharpGroteskBook19.16aedd1a.woff";